module.exports = __webpack_public_path__ + "img/title.7b66d3dd.png";